import { LoadingStates } from '@pb/utils'

import { KlarnaState } from '../types'

const initialState: KlarnaState = {
  payments: {
    initStatus: LoadingStates.NotLoaded,
    authStatus: LoadingStates.NotLoaded,
    paymentMethodCategory: {},
  },
  storeActivation: {
    sessionStatus: LoadingStates.NotLoaded,
  },
  memberInfo: {
    validated: false,
    joinClub: false,
    password: '',
    dateOfBirth: '',
  },
}

export default initialState
